import { useEffect, useRef } from 'react';

const CTASection = () => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('opacity-100', 'translate-y-0');
            entry.target.classList.remove('opacity-0', 'translate-y-8');
          }
        });
      },
      { threshold: 0.15 }
    );
    ref.current?.querySelectorAll('.reveal').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="relative overflow-hidden py-36 lg:py-44 bg-[#0B0B0D]">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/d43b42ff41593f5b6b95a46c9bc03e36.jpg"
          alt="LOPES BUSINESS — Estrutura Internacional"
          className="w-full h-full object-cover object-top opacity-10"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0B0B0D]/80 via-[#0B0B0D]/60 to-[#0B0B0D]/80" />
      </div>

      {/* Glow */}
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[250px] pointer-events-none"
        style={{ background: 'radial-gradient(ellipse, rgba(201,169,110,0.07) 0%, transparent 70%)' }}
      />

      <div className="relative z-10 max-w-3xl mx-auto px-6 text-center">
        <div className="reveal opacity-0 translate-y-8 transition-all duration-700">
          <span className="font-sans text-xs font-medium tracking-[0.3em] uppercase text-[#C9A96E] block mb-6">
            Próximo Passo
          </span>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-[3.25rem] font-light text-white leading-snug mb-6">
            Entre em contato e estruture sua carreira e{' '}
            <em className="not-italic text-[#C9A96E]">patrimônio</em>{' '}
            com segurança.
          </h2>
          <div className="w-10 h-px bg-[#C9A96E]/40 mx-auto mb-8" />
          <p className="font-sans text-base font-light text-white/50 leading-relaxed mb-10">
            Atendimento exclusivo e confidencial — soluções personalizadas para quem opera no mais alto nível.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://wa.me/5547997236779"
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center gap-3 font-sans text-sm font-semibold tracking-[0.2em] uppercase bg-[#C9A96E] text-[#0B0B0D] px-10 py-4 rounded-full transition-all duration-300 hover:opacity-90 cursor-pointer whitespace-nowrap"
              style={{ boxShadow: '0 0 28px rgba(201,169,110,0.25)' }}
            >
              <i className="ri-whatsapp-line text-base" />
              Fale com um Especialista
            </a>
            <a
              href="/servicos"
              className="inline-flex items-center font-sans text-sm font-medium tracking-[0.2em] uppercase border border-white/15 text-white/60 px-10 py-4 rounded-full hover:border-[#C9A96E]/40 hover:text-[#C9A96E] transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Ver Serviços
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
